// extracted by mini-css-extract-plugin
module.exports = {"container":"im","containerExpand":"in","headerRow":"io","headerCol":"ip","image":"iq","title":"ir","date":"is","dateExpand":"it"};